<div class="header">
  <div class="header-cont">
    <h2>{{itin_current.itin_name[current_lang]}}</h2>
    <div
      [matTooltip]="'admin_single_itin.disabled' | translate"
      [matTooltipDisabled]="!isDisabled">
      <button
        mat-raised-button
        class="page-header-btns remove-element"
        (click)="elemDelete()"
        *ngIf="onlyAdmin()"
        [disabled]="isDisabled">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h4>{{ 'admin_single_itin.sections.name' | translate }}</h4>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <mat-tab-group>
      <mat-tab label="Italiano">
        <mat-form-field class="section-input">
          <mat-label>{{ 'admin_single_itin.sections.name' | translate }}</mat-label>
          <input matInput maxlength="255" type="text" [(ngModel)]="itin_current.itin_name['it']" required>
        </mat-form-field>
      </mat-tab>
      <mat-tab label="Slovenščina">
        <mat-form-field class="section-input">
          <mat-label>{{ 'admin_single_itin.sections.name' | translate }}</mat-label>
          <input matInput maxlength="255" type="text" [(ngModel)]="itin_current.itin_name['sl']" required>
        </mat-form-field>
      </mat-tab>
      <mat-tab label="English">
        <mat-form-field class="section-input">
          <mat-label>{{ 'admin_single_itin.sections.name' | translate }}</mat-label>
          <input matInput maxlength="255" type="text" [(ngModel)]="itin_current.itin_name['en']" required>
        </mat-form-field>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h4>{{ 'admin_single_itin.sections.short_descr' | translate }}</h4>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <mat-tab-group>
      <mat-tab label="Italiano">
        <mat-form-field class="section-input">
          <mat-label>{{ 'admin_single_itin.sections.short_descr' | translate }}</mat-label>
          <textarea matInput [(ngModel)]="itin_current.short_descr['it']" maxlength="385" required></textarea>
        </mat-form-field>
      </mat-tab>
      <mat-tab label="Slovenščina">
        <mat-form-field class="section-input">
          <mat-label>{{ 'admin_single_itin.sections.short_descr' | translate }}</mat-label>
          <textarea matInput [(ngModel)]="itin_current.short_descr['sl']" maxlength="385" required></textarea>
        </mat-form-field>
      </mat-tab>
      <mat-tab label="English">
        <mat-form-field class="section-input">
          <mat-label>{{ 'admin_single_itin.sections.short_descr' | translate }}</mat-label>
          <textarea matInput [(ngModel)]="itin_current.short_descr['en']" maxlength="385" required></textarea>
        </mat-form-field>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h4>{{ 'admin_single_itin.sections.descr' | translate }}</h4>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <mat-tab-group>
      <mat-tab label="Italiano">
        <mat-form-field class="section-input">
          <mat-label>{{ 'admin_single_itin.sections.descr' | translate }}</mat-label>
          <textarea matInput [(ngModel)]="itin_current.description['it']" required></textarea>
        </mat-form-field>
      </mat-tab>
      <mat-tab label="Slovenščina">
        <mat-form-field class="section-input">
          <mat-label>{{ 'admin_single_itin.sections.descr' | translate }}</mat-label>
          <textarea matInput [(ngModel)]="itin_current.description['sl']" required></textarea>
        </mat-form-field>
      </mat-tab>
      <mat-tab label="English">
        <mat-form-field class="section-input">
          <mat-label>{{ 'admin_single_itin.sections.descr' | translate }}</mat-label>
          <textarea matInput [(ngModel)]="itin_current.description['en']" required></textarea>
        </mat-form-field>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h4>{{ 'admin_single_itin.sections.trivia' | translate }}</h4>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <mat-tab-group>
      <mat-tab label="Italiano">
        <mat-form-field class="section-input">
          <mat-label>{{ 'admin_single_itin.sections.trivia' | translate }}</mat-label>
          <textarea matInput [(ngModel)]="itin_current.trivia['it']" required></textarea>
        </mat-form-field>
      </mat-tab>
      <mat-tab label="Slovenščina">
        <mat-form-field class="section-input">
          <mat-label>{{ 'admin_single_itin.sections.trivia' | translate }}</mat-label>
          <textarea matInput [(ngModel)]="itin_current.trivia['sl']" required></textarea>
        </mat-form-field>
      </mat-tab>
      <mat-tab label="English">
        <mat-form-field class="section-input">
          <mat-label>{{ 'admin_single_itin.sections.trivia' | translate }}</mat-label>
          <textarea matInput [(ngModel)]="itin_current.trivia['en']" required></textarea>
        </mat-form-field>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h4>{{ 'admin_single_itin.sections.themes' | translate }}</h4>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <mat-selection-list #themesSelection (selectionChange)="themesSelectionFunction()">
      <mat-list-option *ngFor="let theme of themes_list" color="primary" [selected]="checkDict(itin_current.themes, theme.id)" [value]="theme">
        <mat-icon matListIcon>explore</mat-icon>
        {{theme.name[current_lang]}}
      </mat-list-option>
    </mat-selection-list>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h4>{{ 'admin_single_itin.sections.geopos' | translate }}</h4>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <mat-selection-list>
      <mat-list-option *ngFor="let geopos of geopos_list" color="primary" [selected]="checkGeopos(geopos)" disabled>
        <mat-icon matListIcon>explore</mat-icon>
        {{geopos.name[current_lang]}}
      </mat-list-option>
    </mat-selection-list>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont headers-with-input">
    <h4>{{ 'admin_single_itin.sections.pois' | translate }}</h4>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'admin_single_itin.sections.search_poi' | translate }}</mat-label>
      <input matInput (keyup)="applyFilter($event)">
    </mat-form-field>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <mat-selection-list #poiSelection (selectionChange)="poiSelectionFunction()">
      <mat-list-option *ngFor="let poi of poi_list" color="primary" [selected]="checkDict(itin_current.pois, poi.id)" [value]="poi">
        <mat-icon matListIcon>place</mat-icon>
        {{poi.poi_name[current_lang]}}
      </mat-list-option>
    </mat-selection-list>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h4>{{ 'single_itin.audio_icon' | translate }}</h4>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <ng-container *ngIf="checkAttachments(itin_current.attachments, 'audio'); else noAudioUploaded">
      <mat-selection-list #titleAudio (selectionChange)="titleAudioSelection()">
        <mat-list-option *ngFor="let audio of singleTypeAttachments(itin_current.attachments, 'audio')" color="primary" [selected]="audio.title_audio === true" [disabled]="titleAudioDisabled()" [value]="audio">
          <mat-icon matListIcon>volume_up</mat-icon>
          <div class="option-text">
            <span class="file-name">{{audio.name}} - </span>
            <span class="source-text" [matTooltip]="audio.source" [matTooltipPosition]="'above'">{{audio.source}}</span>
          </div>
        </mat-list-option>
      </mat-selection-list>
    </ng-container>
    <ng-template #noAudioUploaded>
      <p class="no-attach">
        <span>{{ 'single_itin.no_audio' | translate: {itin_name: itin_current.itin_name[current_lang]} }}</span>
      </p>
    </ng-template>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h4>{{ 'single_itin.avatar' | translate }}</h4>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <ng-container *ngIf="checkAttachments(itin_current.attachments, 'avatar'); else noAvatarUploaded">
      <mat-selection-list #avatar (selectionChange)="attachmentSelectionFunction()">
        <mat-list-option *ngFor="let pic of singleTypeAttachments(itin_current.attachments, 'avatar')" color="primary" [value]="pic">
          <mat-icon matListIcon>add_to_photos</mat-icon>
          <div class="option-text">
            <span class="file-name">{{pic.name}} - </span>
            <span class="source-text" [matTooltip]="pic.source" [matTooltipPosition]="'above'">{{pic.source}}</span>
          </div>
        </mat-list-option>
      </mat-selection-list>
    </ng-container>
    <ng-template #noAvatarUploaded>
      <p class="no-attach">
        <span>{{ 'new_poi.no_pics' | translate }}</span>
      </p>
    </ng-template>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h4>{{ 'admin_single_itin.sections.pics' | translate }}</h4>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <ng-container *ngIf="checkAttachments(itin_current.attachments, 'picture'); else noPics">
      <mat-selection-list #picSelection (selectionChange)="attachmentSelectionFunction()">
        <mat-list-option *ngFor="let pic of singleTypeAttachments(itin_current.attachments, 'picture')" color="primary" [value]="pic">
          <mat-icon matListIcon>camera_alt</mat-icon>
          <div class="option-text">
            <span class="file-name">{{pic.name}} - </span>
            <span class="source-text" [matTooltip]="pic.source" [matTooltipPosition]="'above'">{{pic.source}}</span>
          </div>
        </mat-list-option>
      </mat-selection-list>
    </ng-container>
    <ng-template #noPics>
      <p class="no-attach">
        <span>{{ 'single_itin.no_pics' | translate: {itin_name: itin_current.itin_name[current_lang]} }}</span>
      </p>
    </ng-template>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h4>{{ 'admin_single_itin.sections.audio' | translate }}</h4>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <ng-container *ngIf="checkAttachments(itin_current.attachments, 'audio'); else noAudio">
      <mat-selection-list #audioSelection (selectionChange)="attachmentSelectionFunction()">
        <mat-list-option *ngFor="let audio of singleTypeAttachments(itin_current.attachments, 'audio')" color="primary" [value]="audio">
          <mat-icon matListIcon>volume_up</mat-icon>
          <div class="option-text">
            <span class="file-name">{{audio.name}} - </span>
            <span class="source-text" [matTooltip]="audio.source" [matTooltipPosition]="'above'">{{audio.source}}</span>
          </div>
        </mat-list-option>
      </mat-selection-list>
    </ng-container>
    <ng-template #noAudio>
      <p class="no-attach">
        <span>{{ 'single_itin.no_audio' | translate: {itin_name: itin_current.itin_name[current_lang]} }}</span>
      </p>
    </ng-template>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h4>{{ 'admin_single_itin.sections.docs' | translate }}</h4>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <ng-container *ngIf="checkAttachments(itin_current.attachments, 'document'); else noDocs">
      <mat-selection-list #docSelection (selectionChange)="attachmentSelectionFunction()">
        <mat-list-option *ngFor="let doc of singleTypeAttachments(itin_current.attachments, 'document')" color="primary" [value]="doc">
          <mat-icon matListIcon>subject</mat-icon>
          <div class="option-text">
            <span class="file-name">{{doc.name}} - </span>
            <span class="source-text" [matTooltip]="doc.source" [matTooltipPosition]="'above'">{{doc.source}}</span>
          </div>
        </mat-list-option>
      </mat-selection-list>
    </ng-container>
    <ng-template #noDocs>
      <p class="no-attach">
        <span>{{ 'single_itin.no_docs' | translate: {itin_name: itin_current.itin_name[current_lang]} }}</span>
      </p>
    </ng-template>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h4>{{ 'admin_single_itin.sections.video' | translate }}</h4>
  </div>
</div>

<div class="single-section">
  <div class="section-cont">
    <ng-container *ngIf="checkAttachments(itin_current.attachments, 'video'); else noVideo">
      <mat-selection-list #videoSelection (selectionChange)="attachmentSelectionFunction()">
        <mat-list-option *ngFor="let video of singleTypeAttachments(itin_current.attachments, 'video')" color="primary" [value]="video">
          <mat-icon matListIcon>movie</mat-icon>
          <div class="option-text">
            <span class="file-name">{{video.name}}</span>
            <span *ngIf="!!video.source" class="source-text" [matTooltip]="video.source" [matTooltipPosition]="'above'">- {{video.source}}</span>
          </div>
        </mat-list-option>
      </mat-selection-list>
    </ng-container>
    <ng-template #noVideo>
      <p class="no-attach">
        <span>{{ 'single_itin.no_video' | translate: {itin_name: itin_current.itin_name[current_lang]} }}</span>
      </p>
    </ng-template>
  </div>
</div>

<div class="page-footer">
  <div class="page-footer-btns">
    <button mat-raised-button class="generic-btn" (click)="addAtt()">
      <mat-icon>attach_file</mat-icon>
    </button>
    <button mat-raised-button class="generic-btn" (click)="addVid()">
      <mat-icon>videocam</mat-icon>
    </button>
    <button mat-raised-button class="generic-btn" (click)="addAva()">
      <mat-icon>add_to_photos</mat-icon>
    </button>
    <button mat-raised-button class="remove-icon-btn" (click)="remAtt()">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
</div>

<div class="page-footer">
  <div
    class="page-footer-btns"
    [matTooltip]="'admin_single_itin.disabled' | translate"
    [matTooltipDisabled]="!isDisabled">
    <button
      mat-raised-button
      class="save-icon-btn"
      (click)="saveItin()"
      [disabled]="isDisabled">
      <mat-icon>save</mat-icon>
    </button>
  </div>
</div>

<app-loading-overlay [loading]="loading"></app-loading-overlay>
